import * as React from 'react';
import { SVGProps } from 'react';

const IconDebugSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.171 10.758A5.002 5.002 0 0 0 8.998 3.1V1.072a7.002 7.002 0 0 1 4.608 11.122L12.17 10.76ZM6.998 1.071a7.002 7.002 0 0 0-4.606 11.12l1.435-1.435A5.002 5.002 0 0 1 6.998 3.1V1.07ZM8 13a4.977 4.977 0 0 1-2.76-.83l-1.434 1.435A6.969 6.969 0 0 0 8 15a6.97 6.97 0 0 0 4.191-1.393l-1.435-1.435A4.977 4.977 0 0 1 8 13ZM6.5 10.5l4-2.5-4-2.5v5Z" />
  </svg>
);
export default IconDebugSizeS;
